import { render, staticRenderFns } from "./clarificaitonModel.vue?vue&type=template&id=04cd0397&scoped=true"
import script from "./clarificaitonModel.vue?vue&type=script&lang=js"
export * from "./clarificaitonModel.vue?vue&type=script&lang=js"
import style0 from "./../project.scss?vue&type=style&index=0&id=04cd0397&prod&lang=scss&scoped=true&external"
import style1 from "./clarificaitonModel.vue?vue&type=style&index=1&id=04cd0397&prod&lang=scss&scoped=true"
import style2 from "./clarificaitonModel.vue?vue&type=style&index=2&id=04cd0397&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd0397",
  null
  
)

export default component.exports